// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

export function searchList (data) {
  return request({
    url: '/api/TrainCourse/searchList',
    method: 'post',
    data,
  })
}

export function searchInit (data) {
    return request({
      url: '/api/TrainCourse/searchInit',
      method: 'post',
      data,
    })
}

export function courseAddInit (data) {
  return request({
    url: '/api/TrainCourse/courseAddInit',
    method: 'post',
    data,
  })
}
export function courseAddSave (data) {
  return request({
    url: '/api/TrainCourse/save',
    method: 'post',
    data,
  })
}

export function courseDetail (data) {
  return request({
    url: '/api/TrainCourse/detail',
    method: 'post',
    data,
  })
}

export function courseAddDetail (data) {
  return request({
    url: '/api/TrainCourse/addDetail',
    method: 'post',
    data,
  })
}

export function courseAddUpdate (data) {
  return request({
    url: '/api/TrainCourse/update',
    method: 'post',
    data,
  })
}


export function courseDelete (data) {
    return request({
      url: '/api/TrainCourse/delete',
      method: 'post',
      data,
    })
}
  
  export function majorList (data) {
    return request({
      url: '/api/TrainMajor/searchList',
      method: 'post',
      data,
    })
  }

  export function majorSave (data) {
    return request({
      url: '/api/TrainMajor/save',
      method: 'post',
      data,
    })
  }
  export function majorDelete (data) {
    return request({
      url: '/api/TrainMajor/delete',
      method: 'post',
      data,
    })
  }
  export function majorUpdate (data) {
    return request({
      url: '/api/TrainMajor/update',
      method: 'post',
      data,
    })
  }
